import { useState } from 'react';
import { Button, DatePicker, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import RiskRegisterService from '../../../../services/RiskRegister.service';
import UserService from '../../../../services/UserService';
import useNotify from '../../../../context/Notification/useNotify';

const ModalReviewed = ({ open, handelClose, getDetailInfo, status }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const currentUser = UserService.getUsername();
    const reviewBy = UserService.getUi();
    let { riskId } = useParams();
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState();
    const notify = useNotify();

    const onFinish = async (values) => {
        const payload = {
            riskRegisterId: riskId,
            status,
            lastReviewDate: values.lastReviewDate.toISOString(),
            nextReviewDue: values.nextReviewDue
                ? values.nextReviewDue.toISOString()
                : '',
            reason: '',
            comment: values.comment,
        };
        setLoading(true);
        setTimeout(async () => {
            try {
                const { data } = await RiskRegisterService.changeStatus(
                    payload
                );
                if (data.resultCode === 1) {
                    getDetailInfo();
                    setLoading(false);
                    handelClose();
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                }
                form.resetFields();
            } catch (error) {
                console.log(error);
                setLoading(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        }, 1300);
    };

    const disabledDateStart = (current) => {
        return current && current > endDate;
    };

    const disabledDate = (current) => {
        return current && current < startDate;
    };

    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                form={form}
                onFinish={onFinish}
                layout="vertical"
                initialValues={{
                    reviewBy,
                    lastReviewDate: moment(),
                    nextReviewDue: '',
                }}
            >
                <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                    <div className="text-2xl font-semibold">
                        {t('RR.ReviewComplete')}
                    </div>
                </div>
                <div className="mt-6 mb-24">
                    <Form.Item
                        label={t('dataInventory.ReviewBy')}
                        name="reviewBy"
                    >
                        {localStorage.getItem('name')
                            ? localStorage.getItem('name')
                            : currentUser}
                    </Form.Item>
                    <Form.Item
                        label={t('dataInventory.LastReviewDate')}
                        name="lastReviewDate"
                        rules={[
                            {
                                required: true,
                                message: t('RR.PleaseInputLastReviewDate'),
                            },
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            showTime
                            format="DD/MM/YYYY HH:mm"
                            placeholder={t('RR.PleaseSelectLastReviewDate')}
                            onChange={(value) => {
                                setStartDate(value);
                            }}
                            disabledDate={disabledDateStart}
                        />
                    </Form.Item>
                    <Form.Item
                        label={t('dataInventory.NextReviewDue')}
                        name="nextReviewDue"
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            showTime
                            disabledDate={disabledDate}
                            onChange={(value) => {
                                setEndDate(value);
                            }}
                            format="DD/MM/YYYY HH:mm"
                            placeholder={t('RR.PleaseSelectNextReviewDue')}
                        />
                    </Form.Item>
                    <Form.Item label={t('Additional comments')} name="comment">
                        <Input.TextArea maxLength={500} showCount rows={4} />
                    </Form.Item>
                </div>
                <div className="flex justify-center items-center space-x-4">
                    <Button
                        type="primary"
                        onClick={handelClose}
                        size="large"
                        ghost
                    >
                        {t('common.Cancel')}
                    </Button>

                    <Button
                        loading={loading}
                        size="large"
                        htmlType="submit"
                        type="primary"
                    >
                        {t('common.Confirm')}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};
export default ModalReviewed;
